<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.review.actions.unfeature.title')"
    :info="$t('components.review.actions.unfeature.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.review.actions.unfeature.confirm'), type: 'confirm', variant: 'success', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Review } from '~/_api/models/review'

interface Props {
  portal?: string | null
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'update:review', value: Review): void
  (e: 'error'): void
}

withDefaults(defineProps<Props>(), {
  portal: null,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const review = ref<Review | null>(null)

const open = (item: Review) => {
  review.value = item
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.review.unfeature(review.value!)

    if (response.data) {
      emit('success')
      emit('update:review', response.data)

      $notification.toast({
        title: $i18n.t('components.review.actions.unfeature.success'),
        text: $i18n.t('components.review.actions.unfeature.successInfo'),
      })

      return true
    }
  } catch (e: any) {
    console.log(e)

    emit('error')
    $notification.error({ errors: e?.errors })
  }
}

defineExpose({ open })
</script>
